import React, { useEffect, useState, useRef } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import logger from "../../../../../../utils/logger";
import {
  addLocationResource,
  editLocationResource,
  getLocation,
  getLocItemResource,
  getLocItemResourceRequest,
  loadResourceItem,
} from "../../../../../controller/reducer/locationResources";
import TagSelector from "../../../common/tag-selector";
import TagDisplay from "../../../common/tags";
import "./styles.css";

function LocationResEditor() {
  const resRequest = useSelector(getLocItemResourceRequest);
  const res = useSelector(getLocItemResource);
  const loc = useSelector(getLocation);
  const dispatch = useDispatch();
  const history = useHistory();
  const [tags, setTags] = useState(
    resRequest.tags ? resRequest.tags.map((t) => ({ value: t, label: t })) : []
  );
  const [title, setTitle] = useState(resRequest.title);
  const [link, setLink] = useState(resRequest.link);
  const [reason, setReason] = useState("");
  const ref = useRef(null);

  logger()(resRequest);
  logger()(res);

  useEffect(() => {
    if (resRequest.type === "edit") {
      dispatch(loadResourceItem(resRequest.linkedTo));
    }
    if (!resRequest._id) {
      history.push("/admin");
    }
  }, [dispatch, resRequest]);

  const submit = (result) => {
    const data = {
      id: resRequest._id,
      title,
      link,
      tags: tags.map((t) => t.value),
      email: resRequest.email,
      result,
      reason,
      location: resRequest.location,
      ref: ref.current === null ? "" : ref.current.innerHTML,
    };
    logger()(data);
    if (resRequest.type === "edit") {
      dispatch(editLocationResource(data));
    } else {
      dispatch(addLocationResource(data));
    }
    onBack();
  };

  const onBack = () => history.push("/admin/location/" + loc.split(" ").join("_"));

  const submitTask = (e) => {
    e.preventDefault();
    submit("accept");
  };
  const reject = (e) => {
    e.preventDefault();
    submit("reject");
    logger()("reject");
  };

  return (
    <Row>
      <Col ref={ref}>
        <Card
          border="info"
          className="remedy-card"
          style={{ minWidth: "18rem" }}
        >
          <Card.Header>NEW {resRequest.location} Resource</Card.Header>
          <Card.Body>
            <Card.Title className="text-center">{title}</Card.Title>
            <Card.Text className="text-center d-flex justify-content-around">
              <Card.Link
                className="text-truncate"
                target="_blank"
                style={{ display: "table-cell" }}
                href={link}
              >
                {link}
              </Card.Link>
            </Card.Text>
            <TagDisplay tags={tags.map((t) => t.value)} />
          </Card.Body>
        </Card>
        {resRequest.type === "edit" && res.link && (
          <Card
            border="info"
            className="remedy-card"
            style={{ minWidth: "18rem" }}
          >
            <Card.Header>OLD {resRequest.location} Resource</Card.Header>
            <Card.Body>
              <Card.Title className="text-center">{res.title}</Card.Title>
              <Card.Text className="text-center d-flex justify-content-around">
                <Card.Link
                  className="text-truncate"
                  target="_blank"
                  style={{ display: "table-cell" }}
                  href={res.link}
                >
                  {res.link}
                </Card.Link>
              </Card.Text>
              <TagDisplay tags={res.tags} />
            </Card.Body>
          </Card>
        )}
      </Col>
      <Col md={6}>
        <Card border="info" className="m-3">
          <Card.Header>
            <Card.Title>
              Suggest Changes in Resource{" "}
              <p style={{cursor:"pointer"}} className="badge badge-success" onClick={onBack}>{loc}</p>
            </Card.Title>
          </Card.Header>
          <Form onSubmit={submitTask}>
            <Card.Body>
              <Form.Group controlId="title">
                <Form.Label inline>Entered Title</Form.Label>
                <Form.Control
                  maxLength="200"
                  required
                  type="text"
                  placeholder="Title"
                  value={title}
                  onChange={(e) => setTitle(e.currentTarget.value)}
                />
                <Form.Text className="text-muted">
                  It is as descriptive as possible
                </Form.Text>
              </Form.Group>
              <Form.Group controlId="link">
                <Form.Label>Entered Url*</Form.Label>
                <Form.Control
                  required
                  type="url"
                  placeholder="Link"
                  value={link}
                  onChange={(e) => setLink(e.currentTarget.value)}
                />
                <Form.Text className="text-muted">
                  Url should be working
                </Form.Text>
              </Form.Group>
              <Form.Group controlId="tags">
                <Form.Label>Selected Tags</Form.Label>
                <TagSelector isRemedy={false} tags={tags} setTags={setTags} />
              </Form.Group>
              {resRequest.type === "edit" && (
                <Form.Group controlId="comment">
                  <Form.Label>Entered Comment</Form.Label>
                  <Form.Control
                    readOnly
                    type="text"
                    placeholder="Comment"
                    value={resRequest.comment}
                  />
                  <Form.Text className="text-muted">
                    Justifies the changes made by the user
                  </Form.Text>
                </Form.Group>
              )}
              <Form.Group controlId="email">
                <Form.Label>Entered Email</Form.Label>
                <Form.Control
                  readOnly
                  type="email"
                  placeholder="Email Here"
                  value={resRequest.email}
                />
                <Form.Text className="text-muted">
                  Entered email will receive response for your decision
                </Form.Text>
              </Form.Group>
            </Card.Body>
            <Card.Footer>
              <Button block variant="primary" type="submit">
                Accept
              </Button>
            </Card.Footer>
          </Form>
          <Form onSubmit={reject}>
            <Card.Body>
              <Form.Group controlId="reason">
                <Form.Label inline>Entered Reason</Form.Label>
                <Form.Control
                  maxLength="200"
                  type="text"
                  placeholder="Reason"
                  value={reason}
                  onChange={(e) => setReason(e.currentTarget.value)}
                />
                <Form.Text className="text-muted">Make it specific</Form.Text>
              </Form.Group>
            </Card.Body>

            <Card.Footer>
              <Button block variant="danger" type="submit">
                Reject
              </Button>
            </Card.Footer>
          </Form>
        </Card>
      </Col>
    </Row>
  );
}

export default LocationResEditor;
